var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#BABABA;stroke-width:2.5593;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#CFCFCF;}\n\t.st2{fill:#F2F2F2;}\n\t.st3{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.5593;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#D2D2D2;}\n\t.st5{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.9,182.9v10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.9,187.9h10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.4,4.8v10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.5,9.8h10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.1,21.3v10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.1,26.3h10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.9,28.9c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3C189.6,27.8,190.6,28.9,191.9,28.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.2,73.4c1.3,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3S270.9,73.4,272.2,73.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.8,231c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3C170.5,230,171.6,231,172.8,231z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94,46.4c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3C91.7,45.3,92.7,46.4,94,46.4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.3,98.7c-19.5,0-39.3-0.8-57.8-5.9c-18.5-5.1-34.8-14.8-49.8-26.2C89.9,59.2,81,53.3,68.4,54.2 C56,54.9,44.2,59.5,34.6,67.4c-16.2,14.1-13.6,40.2-7.2,58.5c9.7,27.6,39.1,46.8,64.2,59.3c28.9,14.4,60.7,22.8,92.5,27.7 c28.2,4.2,63.8,7.3,88-10.9c22.2-16.7,28.3-55,22.9-80.8c-1.3-7.6-5.4-14.5-11.4-19.4c-15.6-11.4-38.9-3.8-56.5-3.4 C220.6,98.5,214,98.7,207.3,98.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.7,258.2c47.2,0,85.4-2.4,85.4-5.3c0-2.9-38.2-5.3-85.4-5.3s-85.4,2.4-85.4,5.3 C74.3,255.8,112.5,258.2,159.7,258.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.9,81.1h-16v131.4h16V81.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.3,81.1h-16v131.4h16V81.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.6,81.1h-16v131.4h16V81.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.8,204.1H70.3v12.5h178.5V204.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.8,83.8H70.3v12.5h178.5V83.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.2,84.5L159.7,25.2L59.1,84.5H260.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M160.4,76.9c10.1,0,18.4-8.2,18.4-18.4c0-10.1-8.2-18.4-18.4-18.4c-10.1,0-18.4,8.2-18.4,18.4 C142,68.7,150.2,76.9,160.4,76.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M159.5,70.5v-2.9c-1.6,0-3.2-0.4-4.5-1.3l0.7-1.9c1.3,0.8,2.7,1.2,4.2,1.2c2.1,0,3.5-1.2,3.4-2.9 c0-1.7-1.2-2.6-3.3-3.4c-3-1.2-4.8-2.6-4.9-5.1c0-1.2,0.5-2.3,1.3-3.2c0.8-0.9,1.9-1.4,3.1-1.5v-2.8h1.8v2.8c1.3,0,2.6,0.3,3.8,1 l-0.7,1.9c-1.1-0.7-2.4-1-3.7-0.9c-2.3,0-3.1,1.4-3.1,2.6c0,1.2,1.1,2.3,3.7,3.3c3,1.2,4.5,2.7,4.6,5.3c0,1.3-0.5,2.5-1.3,3.4 c-0.8,0.9-2,1.5-3.3,1.7v3L159.5,70.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBank);
export default __webpack_public_path__ + "static/media/no-bank.13339945bc2117e6a8f37138bb0043eb.svg";
export { ForwardRef as ReactComponent };